import { post, get, deletefn, putfun } from './http.js'
export default {
  // 职位列表分类
  async jobCategoriesList (params) {
    return await get ('/job-categories')
  },
  // 职位列表
  async jobList (params) {
    return await post ('/job',params)
  },
  // 职位详情
  async jobDetail (params) {
    return await get (`/job/${params}`)
  },
  // 职位投递
  async jobDeliver (params) {
    return await post (`/job-deliver/${params}`)
  },
  // 职位投递
  async jobConnect (params) {
    return await post (`/job-connect/${params}`)
  },
}



// WEBPACK FOOTER //
// ./src/request/job.js